import React, { Fragment, useEffect, useState } from 'react';
import styles from './SearchString.module.scss';
import LoaderButton from '../../LoaderButton/LoaderButton';
import { CLOSE, SEARCH } from "@/src/lib/SmartDB/Commons/Constants/images";

interface ISearchStringProps {
    isLoadingList: boolean;
    width?: number;
    searchString: string;
    setSearchString: (searchString: string) => void;
    placeHolder?: string;
}

const SearchString: React.FC<ISearchStringProps> = (props) => {
    //--------------------------------------
    const { isLoadingList, width, setSearchString, searchString, placeHolder } = props;
    //--------------------------------------
    // const [isSearching, setIsSearching] = useState(false);
    const [searchString_, setSearchString_] = useState<string>(searchString);
    //--------------------------------------
    const handleSearchStringChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        setSearchString_(inputValue);
        // setSearchString(inputValue);
    };
    const handleClickSearchString = () => {
        const inputElement = document.querySelector(`.${styles.search}`) as HTMLInputElement;
        if (inputElement) {
            inputElement.focus();
        }
        // console.log(`handleClickSearchString ${searchString_}`);
        if (isLoadingList === false) {
            setSearchString(searchString_);
            // setIsSearching(true);
        }
    };
    const handleClickCancel = () => {
        const inputElement = document.querySelector(`.${styles.search}`) as HTMLInputElement;
        if (inputElement) {
            inputElement.focus();
        }
        setSearchString_('');
        setSearchString('');
        // setIsSearching(false);
    };
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Check if the Enter key was pressed
        if (e.key === 'Enter' && !isLoadingList) {
            setSearchString(searchString_);
            // setIsSearching(true);
        }
    };

    //--------------------------------------
    return (
        <Fragment>
            <div className={styles.searchString} style={{ width: width ? width : '100%' }}>
                <input
                    type="text"
                    className={styles.search}
                    placeholder={placeHolder}
                    value={searchString_}
                    onKeyDown={handleKeyPress}
                    onChange={(e) => {
                        handleSearchStringChange(e);
                    }}
                />
                {isLoadingList ? (
                    <div className={styles.iconLoading}>
                        <LoaderButton />
                    </div>
                ) : (
                    <svg width="16" height="16" className={styles.icon} onClick={handleClickSearchString}>
                        <use href={SEARCH}></use>
                    </svg>
                )}
                {(searchString_ !== '' ) && (
                    <div className={styles.divCancel}>
                        <svg width="20" height="20" className={styles.iconCancel} onClick={handleClickCancel}>
                            <use href={CLOSE}></use>
                        </svg>
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default SearchString;
